// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2xOfH","placeholdersHeader":"styles_placeholdersHeader__1Zhv8","editorStyle":"styles_editorStyle__1BK8_","placeholdersBox":"styles_placeholdersBox__1Z9PE"};